import brand from '@helpers/brand';
import styled, { css } from 'styled-components';
import { CommonTextInputStyles } from '../Textbox/Textbox.styles';
export const CommonTextareaStyles = css `
  ${CommonTextInputStyles};

  height: auto;
  min-height: 100px;

  &[value]:not([value='']),
  &.filled {
    border: 2px solid ${brand.orange.base};
  }
`;
const Input = styled.textarea `
  ${CommonTextareaStyles};
`;
const TextareaStyles = {
    Input,
};
export default TextareaStyles;
